import { useState } from 'react';
import { useAuth } from '@/lib/auth-context';

export default function ProspectOnboard() {
  const { user } = useAuth();
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitted(true);
  };

  return (
    <section className="mx-auto max-w-3xl space-y-6 rounded-3xl bg-white/80 p-6 shadow-soft">
      <header>
        <h1 className="text-2xl font-semibold text-cocoa">Create a new prospect profile</h1>
        <p className="mt-2 text-sm text-cocoa/70">
          Coaches and admins can collect basic details to begin the approval process. We’ll keep this lightweight until the full
          onboarding flow ships.
        </p>
      </header>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid gap-3 md:grid-cols-2">
          <div>
            <label className="text-sm font-medium text-cocoa" htmlFor="first-name">
              First name
            </label>
            <input id="first-name" type="text" className="mt-1 w-full rounded-lg border border-sand bg-white px-3 py-2 text-sm" required />
          </div>
          <div>
            <label className="text-sm font-medium text-cocoa" htmlFor="last-name">
              Last name
            </label>
            <input id="last-name" type="text" className="mt-1 w-full rounded-lg border border-sand bg-white px-3 py-2 text-sm" required />
          </div>
        </div>
        <div>
          <label className="text-sm font-medium text-cocoa" htmlFor="sport">
            Sport & position
          </label>
          <input id="sport" type="text" className="mt-1 w-full rounded-lg border border-sand bg-white px-3 py-2 text-sm" placeholder="Soccer – Midfielder" />
        </div>
        <div>
          <label className="text-sm font-medium text-cocoa" htmlFor="guardian-email">
            Guardian email
          </label>
          <input id="guardian-email" type="email" className="mt-1 w-full rounded-lg border border-sand bg-white px-3 py-2 text-sm" placeholder="parent@example.com" />
        </div>
        <button
          type="submit"
          className="rounded-full bg-brick px-4 py-2 text-sm font-semibold text-white shadow-soft transition hover:bg-brickDark"
        >
          Start onboarding
        </button>
      </form>
      {submitted ? (
        <div className="rounded-lg bg-emerald-50 p-3 text-sm text-emerald-700">
          Thanks, {user?.email || 'coach'}! We’ll follow up with a link to complete the profile and collect consent paperwork.
        </div>
      ) : null}
    </section>
  );
}
